import HiddenFields from "./HiddenFields";
import { useToursContext } from "./context";
import React from "react";

export default function Search() {

    const {
        page: { request },
        showLoader
    } = useToursContext();

    return (
        <div>
            <form onSubmit={showLoader}>
                <HiddenFields omit={'search'} />
                <div className="input-group white border border-3p mb-3 p-1">
                    <input
                        type="text"
                        name="search"
                        defaultValue={request.search}
                        className="form-control form-control-lg border-0 rounded-0"
                        placeholder={"Search tours..."}
                    />
                    <div className="input-group-append">
                        <button className="btn btn-primary border-0 rounded-0 font-weight-bold px-3 px-lg-5" type="submit">
                            <span className="d-none d-lg-inline">Search</span><i className="fa fa-fw fa-search ml-lg-3"></i>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}


// WEBPACK FOOTER //
// ./resources/js/react/components/ToursIndex/Search.jsx